module.exports = __webpack_public_path__ + "img/more.a1def753.png";